'use strict';
import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

const SUMMARY_FIELD_NAME = 'summary';

@Component({
  selector: 'gen-curation-editor-summary',
  templateUrl: './curation-editor-summary.component.html',
  styleUrls: ['./curation-editor-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})

export class CurationEditorSummaryComponent implements OnInit {
  @Input() readOnly = false;
  @Input() title: string;
  @Input() inlineEdit: boolean = false;
  @Input() formName: string;
  @Input() approvedMode: boolean = false;
  @Input() revisionTag: string;
  @Input() submitted: boolean = false;
  @Input() summarySectionTitle: string;
  @Input() copyAllFields: boolean = true;
  @Output() updateSummaryForm: EventEmitter<any> = new EventEmitter();

  private _curationData: any = { };
  public formData: any;
  public formConfig: any;
  private SUMMARY_FIELD_NAME: string = 'summary';
  public fields: string[] = ['conditionIsRadiationDiscipline'];

  @Input() set curationData(data) {
    if (data) {
      this._curationData = data;
      this.formData = { ...this._curationData['content']};
      if (this._curationData[this.SUMMARY_FIELD_NAME]) {
        this.formData['summary'] = this._curationData[this.SUMMARY_FIELD_NAME];
      }
    }
  }

  get updatedFieldsContext() {
    return this.approvedMode ? null : this.revisionTag;
  }

  constructor() { }

  ngOnInit() {
  }

  updateForm(form, updated) {
    this.updateSummaryForm.emit( { form:form, updated: updated});
    if (form && this.copyAllFields) {
      // bypass till we throw old curation v0, and will align with saving all props in content block
      Object.assign(this.SUMMARY_FIELD_NAME in form ? this._curationData : this._curationData['content'], form);
    }

  }
}
